export * from "src/generated/hooks/form-service/requests/types.gen";
export type {
  V3_AddressQuestion as AddressQuestion,
  V3_AddressQuestionWithoutId as AddressQuestionWithoutId,
  V3_BaseOption as BaseOption,
  V3_BaseQuestion as BaseQuestion,
  V3_CustomQuestion as CustomQuestion,
  V3_CustomQuestionWithoutId as CustomQuestionWithoutId,
  V3_DateQuestion as DateQuestion,
  V3_DateQuestionWithoutId as DateQuestionWithoutId,
  V3_DisclaimerSection as DisclaimerSection,
  V3_EmailQuestion as EmailQuestion,
  V3_EmailQuestionWithoutId as EmailQuestionWithoutId,
  V3_FamilyEditableStatusType as FamilyEditableStatusType,
  V3_FileUploadQuestion as FileUploadQuestion,
  V3_FileUploadQuestionWithoutId as FileUploadQuestionWithoutId,
  V3_FormSectionBase as FormSectionBase,
  V3_FormTemplate as FormTemplate,
  V3_FormTemplateWithoutId as FormTemplateWithoutId,
  V3_FreeTextQuestion as FreeTextQuestion,
  V3_FreeTextQuestionWithoutId as FreeTextQuestionWithoutId,
  V3_GeneralSection as GeneralSection,
  V3_GenericSections as GenericSections,
  V3_MultiSelectQuestion as MultiSelectQuestion,
  V3_MultiSelectQuestionWithoutId as MultiSelectQuestionWithoutId,
  V3_NumberQuestion as NumberQuestion,
  V3_NumberWithoutId as NumberWithoutId,
  V3_Option as Option,
  V3_OptionWithoutId as OptionWithoutId,
  V3_PermissionLevel as PermissionLevel,
  V3_PhoneNumberQuestion as PhoneNumberQuestion,
  V3_PhoneNumberQuestionWithoutId as PhoneNumberQuestionWithoutId,
  V3_PreRankingSection as PreRankingSection,
  V3_Question as Question,
  V3_QuestionType as QuestionType,
  V3_QuestionWithoutId as QuestionWithoutId,
  V3_SchoolRankingSection as SchoolRankingSection,
  V3_Section as Section,
  V3_SectionType as SectionType,
  V3_SectionWithoutId as SectionWithoutId,
  V3_SingleSelectQuestion as SingleSelectQuestion,
  V3_SingleSelectQuestionWithoutId as SingleSelectQuestionWithoutId,
} from "src/generated/hooks/form-service/requests/types.gen";

export const SectionTypes = {
  PreRankingSection: "PreRankingSection",
  SchoolRankingSection: "SchoolRankingSection",
  DisclaimerSection: "DisclaimerSection",
  GeneralSection: "GeneralSection",
} as const;

export const SectionTypeList = [
  SectionTypes.PreRankingSection,
  SectionTypes.SchoolRankingSection,
  SectionTypes.GeneralSection,
  SectionTypes.DisclaimerSection,
] as const;

export const QuestionTypes = {
  SingleSelect: "SingleSelect",
  MultiSelect: "MultiSelect",
  FreeText: "FreeText",
  FileUpload: "FileUpload",
  Email: "Email",
  PhoneNumber: "PhoneNumber",
  Address: "Address",
  CustomQuestion: "CustomQuestion",
  Date: "Date",
  Number: "Number",
} as const;

export const QuestionTypeList = [
  QuestionTypes.SingleSelect,
  QuestionTypes.MultiSelect,
  QuestionTypes.FreeText,
  QuestionTypes.FileUpload,
  QuestionTypes.Email,
  QuestionTypes.PhoneNumber,
  QuestionTypes.Address,
  QuestionTypes.CustomQuestion,
  QuestionTypes.Date,
  QuestionTypes.Number,
] as const;
